/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dynamic-slider.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '@covalent/dynamic-forms/dynamic-elements/dynamic-slider/dynamic-slider.component';
import * as i4 from '../../../../@angular/material/typings/index.ngfactory';
import * as i5 from '@angular/forms';
import * as i6 from '@angular/material';
const styles_TdDynamicSliderComponent:any[] = [i0.styles];
export const RenderType_TdDynamicSliderComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TdDynamicSliderComponent,data:{}});
function View_TdDynamicSliderComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',[['class',
      'mat-placeholder-required']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['*']))],(null as any),(null as any));
}
export function View_TdDynamicSliderComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),20,'div',[['class',
      'dynamic-slider-wrapper relative push-top'],['flex',''],['layout','column']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      3,'label',[['class','mat-input-placeholder mat-float td-slider-label']],[[2,
          'mat-focused',(null as any)]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),[' ',' '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_TdDynamicSliderComponent_1)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),12,'div',[['flex',''],['layout','row'],
              ['layout-align','start center']],(null as any),(null as any),(null as any),
              (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),9,'md-slider',[['class','mat-slider'],
          ['flex',''],['role','slider'],['tabindex','0'],['thumbLabel',''],['tickInterval',
              'auto']],[[1,'required',0],[1,'aria-disabled',0],[1,'aria-valuemax',
          0],[1,'aria-valuemin',0],[1,'aria-valuenow',0],[1,'aria-orientation',0],
          [2,'mat-primary',(null as any)],[2,'mat-accent',(null as any)],[2,'mat-warn',
              (null as any)],[2,'mat-slider-disabled',(null as any)],[2,'mat-slider-has-ticks',
              (null as any)],[2,'mat-slider-horizontal',(null as any)],[2,'mat-slider-axis-inverted',
              (null as any)],[2,'mat-slider-sliding',(null as any)],[2,'mat-slider-thumb-label-showing',
              (null as any)],[2,'mat-slider-vertical',(null as any)],[2,'mat-slider-min-value',
              (null as any)],[2,'mat-slider-hide-last-tick',(null as any)],[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
          [(null as any),'focus'],[(null as any),'blur'],[(null as any),'click'],[(null as any),
              'keydown'],[(null as any),'keyup'],[(null as any),'mouseenter'],[(null as any),
              'slide'],[(null as any),'slideend'],[(null as any),'slidestart']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:i3.TdDynamicSliderComponent = _v.component;
        if (('focus' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,12)._onFocus()) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,12)._onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('click' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,12)._onClick($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('keydown' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,12)._onKeydown($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('keyup' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,12)._onKeyup()) !== false);
          ad = (pd_4 && ad);
        }
        if (('mouseenter' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,12)._onMouseenter()) !== false);
          ad = (pd_5 && ad);
        }
        if (('slide' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,12)._onSlide($event)) !== false);
          ad = (pd_6 && ad);
        }
        if (('slideend' === en)) {
          const pd_7:any = ((<any>i1.ɵnov(_v,12)._onSlideEnd()) !== false);
          ad = (pd_7 && ad);
        }
        if (('slidestart' === en)) {
          const pd_8:any = ((<any>i1.ɵnov(_v,12)._onSlideStart($event)) !== false);
          ad = (pd_8 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_9:any = ((<any>(_co.value = $event)) !== false);
          ad = (pd_9 && ad);
        }
        return ad;
      },i4.View_MdSlider_0,i4.RenderType_MdSlider)),i1.ɵdid(16384,(null as any),0,
          i5.RequiredValidator,([] as any[]),{required:[0,'required']},(null as any)),
      i1.ɵprd(1024,(null as any),i5.NG_VALIDATORS,(p0_0:any) => {
        return [p0_0];
      },[i5.RequiredValidator]),i1.ɵdid(180224,[['slider',4]],0,i6.MdSlider,[i1.Renderer2,
          i1.ElementRef,i6.FocusOriginMonitor,[2,i6.Dir]],{max:[0,'max'],min:[1,'min'],
          thumbLabel:[2,'thumbLabel'],tickInterval:[3,'tickInterval']},(null as any)),
      i1.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i6.MdSlider]),i1.ɵdid(671744,(null as any),0,i5.NgModel,[[8,(null as any)],
          [2,i5.NG_VALIDATORS],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i5.NgControl,
          (null as any),[i5.NgModel]),i1.ɵdid(16384,(null as any),0,i5.NgControlStatus,
          [i5.NgControl],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i6.MdPrefixRejector,[[2,i6.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵted((null as any),['  \n']))],
      (_ck,_v) => {
        var _co:i3.TdDynamicSliderComponent = _v.component;
        const currVal_2:any = _co.required;
        _ck(_v,5,0,currVal_2);
        const currVal_28:any = _co.required;
        _ck(_v,10,0,currVal_28);
        const currVal_29:any = _co.max;
        const currVal_30:any = _co.min;
        const currVal_31:any = '';
        const currVal_32:any = 'auto';
        _ck(_v,12,0,currVal_29,currVal_30,currVal_31,currVal_32);
        const currVal_33:any = _co.value;
        _ck(_v,14,0,currVal_33);
      },(_ck,_v) => {
        var _co:i3.TdDynamicSliderComponent = _v.component;
        const currVal_0:any = i1.ɵnov(_v,12)._isActive;
        _ck(_v,2,0,currVal_0);
        const currVal_1:any = _co.label;
        _ck(_v,3,0,currVal_1);
        const currVal_3:any = (i1.ɵnov(_v,10).required? '': (null as any));
        const currVal_4:any = i1.ɵnov(_v,12).disabled;
        const currVal_5:any = i1.ɵnov(_v,12).max;
        const currVal_6:any = i1.ɵnov(_v,12).min;
        const currVal_7:any = i1.ɵnov(_v,12).value;
        const currVal_8:any = (i1.ɵnov(_v,12).vertical? 'vertical': 'horizontal');
        const currVal_9:any = (i1.ɵnov(_v,12).color == 'primary');
        const currVal_10:any = ((i1.ɵnov(_v,12).color != 'primary') && (i1.ɵnov(_v,
            12).color != 'warn'));
        const currVal_11:any = (i1.ɵnov(_v,12).color == 'warn');
        const currVal_12:any = i1.ɵnov(_v,12).disabled;
        const currVal_13:any = i1.ɵnov(_v,12).tickInterval;
        const currVal_14:boolean = !i1.ɵnov(_v,12).vertical;
        const currVal_15:any = i1.ɵnov(_v,12)._invertAxis;
        const currVal_16:any = i1.ɵnov(_v,12)._isSliding;
        const currVal_17:any = i1.ɵnov(_v,12).thumbLabel;
        const currVal_18:any = i1.ɵnov(_v,12).vertical;
        const currVal_19:any = i1.ɵnov(_v,12)._isMinValue;
        const currVal_20:any = (i1.ɵnov(_v,12).disabled || ((i1.ɵnov(_v,12)._isMinValue && i1.ɵnov(_v,
            12)._thumbGap) && i1.ɵnov(_v,12)._invertAxis));
        const currVal_21:any = i1.ɵnov(_v,16).ngClassUntouched;
        const currVal_22:any = i1.ɵnov(_v,16).ngClassTouched;
        const currVal_23:any = i1.ɵnov(_v,16).ngClassPristine;
        const currVal_24:any = i1.ɵnov(_v,16).ngClassDirty;
        const currVal_25:any = i1.ɵnov(_v,16).ngClassValid;
        const currVal_26:any = i1.ɵnov(_v,16).ngClassInvalid;
        const currVal_27:any = i1.ɵnov(_v,16).ngClassPending;
        _ck(_v,9,1,[currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,
            currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,
            currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,
            currVal_24,currVal_25,currVal_26,currVal_27]);
      });
}
export function View_TdDynamicSliderComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'td-dynamic-slider',
      ([] as any[]),(null as any),(null as any),(null as any),View_TdDynamicSliderComponent_0,
      RenderType_TdDynamicSliderComponent)),i1.ɵprd(5120,(null as any),i5.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i3.TdDynamicSliderComponent]),i1.ɵdid(49152,(null as any),0,i3.TdDynamicSliderComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const TdDynamicSliderComponentNgFactory:i1.ComponentFactory<i3.TdDynamicSliderComponent> = i1.ɵccf('td-dynamic-slider',
    i3.TdDynamicSliderComponent,View_TdDynamicSliderComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/dynamic-forms/dynamic-elements/dynamic-slider/dynamic-slider.component.ngfactory.ts